module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"contact":{"head":"倉庫をお探しの方は、{newline}いつでもお気軽にご相談ください。"}}}')
  delete Component.options._Ctor
}
